/**
 * ListCountBadge — the count, for a list that has no filter bar to put it in.
 *
 * "Showing x of x" belongs on the LEFT of the filter bar, and on every page
 * that owns one it lives there (see `FilterBarWithTabs`). Four views have no
 * bar of their own: the trash/secondary tables that render INSIDE another
 * page, under that page's bar. Their count cannot go in it — while a trash
 * view is open, that bar is describing the list behind it, and putting two
 * different totals in one strip would be worse than a second line.
 *
 * So they get the same sentence, from the same helper, in the same grey
 * badge — just above their own table. One component, so if the wording or the
 * styling moves, it moves for them too.
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import Badge from './Badge';
import { ListCountInput, listCountText } from './listCount';

const ListCountBadge: React.FC<ListCountInput> = (props) => {
  const { t } = useTranslation();
  const text = listCountText(props, t);
  if (!text) return null;
  return (
    <div className="flex flex-shrink-0 items-center px-3 py-2" data-testid="list-count">
      <Badge color="gray">{text}</Badge>
    </div>
  );
};

export default ListCountBadge;
